"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIcon = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const styles_1 = require("@material-ui/core/styles");
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const ButtonIcon_1 = __importDefault(require("./components/ButtonIcon"));
exports.ButtonIcon = ButtonIcon_1.default;
const Box_1 = __importDefault(require("../../layouts/Box"));
const useStyles = styles_1.makeStyles({
    iconButton: {
        padding: '4px 12px',
    },
    loadingIcon: {
        paddingRight: '2px',
    },
});
const OffsetCircularProgress = () => (react_1.default.createElement(Box_1.default, { pr: 0.6 },
    react_1.default.createElement(CircularProgress_1.default, { size: 14 })));
const muiButtonProps = ({ loading, disabled, onClick, variant, href, icon, iconAlign, label, type = 'button', size = 'medium', }) => {
    const getVariantProps = () => {
        switch (variant) {
            case 'link':
                return { href };
            case 'primary':
                return { variant: 'contained', color: 'primary' };
            case 'normal':
                return { variant: 'text' };
        }
        return {};
    };
    return Object.assign(Object.assign(Object.assign({ disabled,
        onClick,
        type,
        size, 'aria-label': label }, (icon && { [iconAlign === 'right' ? 'endIcon' : 'startIcon']: react_1.default.createElement(ButtonIcon_1.default, { type: icon }) })), (loading && { startIcon: react_1.default.createElement(OffsetCircularProgress, null) })), getVariantProps());
};
/**
 * A button allows users to trigger actions on the interface.
 */
const Button = (_a) => {
    var { variant = 'normal', href = '', iconAlign = 'left', onClick, icon, loading, label, disabled, children, type = 'button', size = 'medium' } = _a, props = __rest(_a, ["variant", "href", "iconAlign", "onClick", "icon", "loading", "label", "disabled", "children", "type", "size"]);
    const styles = useStyles({});
    const isDisabled = react_1.useMemo(() => disabled || loading, [disabled, loading]);
    switch (variant) {
        case 'icon':
            return (react_1.default.createElement(IconButton_1.default, Object.assign({}, props, { "aria-label": label, disabled: isDisabled, onClick: onClick, className: styles.iconButton }), loading ? (react_1.default.createElement(CircularProgress_1.default, { size: 14, className: styles.loadingIcon })) : (react_1.default.createElement(ButtonIcon_1.default, { type: icon }))));
        default:
            return (react_1.default.createElement(Button_1.default, Object.assign({}, props, muiButtonProps({
                disabled: isDisabled,
                onClick,
                variant,
                href,
                loading,
                icon,
                iconAlign,
                label,
                type,
                size,
            })), children));
    }
};
exports.default = Button;
